if (!window.hasOwnProperty('singletons')) {
    window.singletons = {};
}

class ScrollCarouselManager {
    list = [];
    filteredTargets = null;
    scrolling = false;

    constructor() {
        if (window.singletons.hasOwnProperty('ScrollCarouselManager')) {
            throw new Error('You can only create one instance!');
        }

        window.singletons.ScrollCarouselManager = this;
        this.debounceScrollHandler = this.__debounce(this.debounceScrollCallback, 250);
        this.__addScrollEvent();
    }

    static getInstance() {
        return window.singletons.hasOwnProperty('ScrollCarouselManager')
            ? window.singletons.ScrollCarouselManager
            : new ScrollCarouselManager();
    }

    __addScrollEvent() {
        window.addEventListener('scroll', this.scrollHandler);
        window.addEventListener('scroll', this.debounceScrollHandler);
    }

    scrollHandler = () => {
        if (!this.scrolling) {
            this.scrolling = true;
            this.allowEventsOnTargets(false);
        }
    };

    debounceScrollCallback = () => {
        this.allowEventsOnTargets();
        this.scrolling = false;
    };

    allowEventsOnTargets(allow = true) {
        let filteredTargets = this.list.filter((target) => {
            return target.disableOnScroll;
        });

        let total = filteredTargets.length;
        for (let index = 0; index < total; index++) {
            const element = filteredTargets[index];
            if (element.disableOnScroll) {
                element.allowEvents(allow);
            }
        }
    }

    __debounce(func, timeout = 1500) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    add(target) {
        this.list.push(target);
    }
}

export default ScrollCarouselManager.getInstance();
